import React from "react";

const Bash_Mkdir = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Mkdir</h2>
      <p>Create directories.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>mkdir [options] dir</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>mkdir project
mkdir -p a/b/c  # creates parent dirs</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -p to create intermediate directories.</p>
    </div>
  );
};

export default Bash_Mkdir;
